import token from "styled-token";
/** @class TriggerTextMixin */

/** @method */

export var TriggerTextMixin = token("TriggerText.borderBottomColor", function (borderColor) {
  return "\n        display: inline;\n        color: inherit;\n        cursor: pointer;\n        font-weight: inherit;\n        font-size: inherit;\n        font-family: inherit;\n        background: none;\n        padding: 0;\n        border: 0;\n        border-bottom: 1px dashed " + (borderColor || "") + ";\n    ";
});